import React from "react";
//Material imports
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import Fade from "@material-ui/core/Fade";
import SlideTitle from "../slide-title/SlideTitle";

var TextSlideBody = function TextSlideBody(_ref) {
  var classes = _ref.classes,
      slide = _ref.slide,
      shouldAnimate = _ref.shouldAnimate;
  var headline = slide.headline,
      backgroundColor = slide.backgroundColor,
      bodyColor = slide.bodyColor;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.textSlideContainer,
    style: {
      backgroundColor: backgroundColor
    }
  }, /*#__PURE__*/React.createElement(SlideTitle, {
    slide: slide,
    gutterBottom: true
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.headlineTextContainer
  }, /*#__PURE__*/React.createElement(Fade, {
    in: true,
    timeout: 400,
    style: {
      transitionDelay: "0.6s"
    },
    appear: shouldAnimate
  }, /*#__PURE__*/React.createElement(Typography, {
    align: "center",
    className: classes.bodyText,
    component: "span",
    style: {
      color: bodyColor,
      backgroundColor: backgroundColor
    },
    gutterBottom: true
  }, /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: headline
    }
  })))));
};

var styles = {
  textSlideContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    paddingTop: 20,
    marginBottom: 16,
    overflow: "hidden"
  },
  "@media screen and (min-width: 450px)": {
    textSlideContainer: {
      borderTopLeftRadius: 12,
      borderTopRightRadius: 12
    }
  },
  headlineTextContainer: {
    flex: "1",
    display: "flex",
    marginLeft: 20,
    marginRight: 20,
    flexDirection: "column",
    overflow: "hidden"
  },
  bodyText: {
    overflow: "auto"
  }
};
export default withStyles(styles)(TextSlideBody);